// @flow
import type {
  OrderTestsOperator,
} from '../types'

// Constants
import { MODEL } from 'hfty-model-order-tests'

// Libs
import composeOperator from 'fc-operations'

// Exports
export const operator: OrderTestsOperator = composeOperator({
  model: MODEL,
  branch: 'orderTestsOperation',
})

export default operator
